import { types, Instance } from 'mobx-state-tree';
const { model, string, maybeNull, maybe, boolean, number } = types;

export const syncUserModel = model('syncUserModel ', {
  cn: maybeNull(string),
  sn: maybeNull(string),
  name: maybe(string),
  description: maybe(string),
  primaryEmail: maybe(string),
  isSuspended: maybe(boolean),
  telephonenumber: maybe(string),
  userpassword: maybe(string),
  homephone: maybe(string),
  isAdmin: maybe(boolean),
  includeInGlobalAddressList: maybe(boolean),
  creationTimestamp: maybeNull(string),
  lastLoginTime: maybeNull(string),
  isMailboxSetup: maybe(boolean),
  googleId: maybeNull(string),
});

export type IsyncUserModel = Instance<typeof syncUserModel>;

export const SelectedUserModel = model('SelectedUserModel', {
  mail: maybe(string),
});
export type ISelectedUserModel = Instance<typeof SelectedUserModel>;

export const syncGroupModel = model('syncGroupModel', {
  mail: maybe(string),
  memberCount: maybe(string),
  nonEditableAliases: maybe(string),
  isAdmin: maybe(boolean),
  adminCreated: maybe(boolean),
  cn: string,
  gidNumber: maybeNull(string),
  description: maybe(string),
});
export type IsyncGroupModel = Instance<typeof syncGroupModel>;

export const syncDepartmentModel = model('syncDepartmentModel', {
  base: maybe(string),
  parentOuId: maybe(string),
  ou: string,
  ouId: maybeNull(string),
  description: maybe(string),
  name: maybe(string),
  orgUnitId: maybe(string),
});
export type IsyncDepartmentModel = Instance<typeof syncDepartmentModel>;

export const StatisticModel = model('StatisticModel', {
  user: number,
  group: number,
  department: number,
});
export type IStatisticModel = Instance<typeof StatisticModel>;
